<template>
  <v-card flat>
    <v-card-title primary-title>
      <h4>Login</h4>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid" ref="form">
        <v-text-field
          label="Enter your e-mail address"
          v-model="email"
          :rules="emailRules"
          required
        ></v-text-field>
        <v-text-field
          label="Enter your password"
          v-model="password"
          min="8"
          :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="e1 = !e1"
          :type="e1 ? 'text' : 'password'"
          :rules="passwordRules"
          counter
          required
        ></v-text-field>
        <div class="pb-1 red--text">{{ error }}</div>
        <v-layout justify-center>
          <v-btn block @click="submit">Login</v-btn>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import client from '@/services/axios';
export default {
  data() {
    return {
      error: '',
      valid: false,
      e1: false,
      password: '',
      email: '',
      passwordRules: [(v) => !!v || 'Password is required'],
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'E-mail must be valid'
      ]
    };
  },
  async created() {
    if (!this.$store.state.namespace) {
      this.$store.commit('SET_ERROR', 'you must specify an event');
      return;
    }
    try {
      await client.get('/events/' + this.$store.state.namespace);
    } catch (err) {
      this.$store.commit('SET_ERROR', err.error);
    }

    // const result = await client.get('/sso/profile');
    // const user = result.data;
    // if (user) {
    //   this.$store.commit('setUser', user);
    // }
  },
  methods: {
    async submit(e) {
      if (this.$refs.form.validate()) {
        e.preventDefault();
        await this.handleLogin();
      }
    },
    async handleLogin() {
      try {
        let result = await client.post('/sso/login', {
          eventId: this.$store.state.namespace,
          email: this.email,
          password: this.password
        });
        let token = result.data.token;

        if (token) {
          this.$store.commit('LOGIN', token);
        }
      } catch (err) {
        this.error = err.error;
      }
    }
  }
};
</script>
